import styled from "styled-components";

const Foto = styled.img`
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin: 30px;
  position: relative;
`;

export default Foto;